module.exports = __webpack_public_path__ + "img/browser_safari.5d2a122c.svg";